import { useQuery } from "@tanstack/react-query";

import { get } from "common/helpers/HTTP";
import type { Invitation } from "common/types";

async function getInvitationsRequest(): Promise<Invitation[]> {
  return (await get("invites")).invites;
}

export default function useInvitations() {
  const { data: invitations, isPending: isLoadingInvitations } = useQuery({
    queryKey: ["invitations"],
    queryFn: getInvitationsRequest,
  });

  return {
    invitations,
    isLoadingInvitations,
  };
}
